import React from 'react';
import { Alert } from '@op/opds.opux';

interface SearchWarningProps {
  message: string;
  isNoResults?: boolean;
}

export const SearchWarning: React.FC<SearchWarningProps> = ({
  message,
  isNoResults
}) => {
  if (isNoResults) {
    const [heading, ...rest] = message.split('.');
    const paragraph = rest.join('.').trim();
    const headingText = paragraph ? `${heading.trim()}.` : heading.trim();
    return (
      <Alert type="warning">
        <h2 className="search-warning-heading">{headingText}</h2>
        {paragraph && <p>{paragraph}</p>}
      </Alert>
    );
  }

  // Split message into two parts at the first period
  const sentences = message.split(/\.\s+/);
  const firstSentence = sentences[0].endsWith('.')
    ? sentences[0]
    : sentences[0] + '.';
  const secondSentence = sentences.slice(1).join('. ');

  return (
    <Alert type="warning">
      <div className="warning-message-container">
        <p className="warning-first-line">{firstSentence}</p>
        {secondSentence && (
          <p className="warning-second-line">{secondSentence}</p>
        )}
      </div>
    </Alert>
  );
};
